import React from 'react';
import { connect } from 'react-redux';
import ReactTable from "react-table";
import { find, maxBy, isEqual, cloneDeep } from 'lodash';

import config from '../../../config/config';
import Box from '../../common/Box';
import CSV from '../../../helpers/CSVExport';
import ModeSelect from '../../common/ModeSelect';
import StackedBarChart from '../../widgets/charts/types/StackedBarChart';
import LineChart from '../../widgets/charts/types/LineChartWithAnnotations';

const lineSvg = require('!svg-inline-loader!../../../../public/img/line.svg');
const tableSvg = require('!svg-inline-loader!../../../../public/img/table.svg');
const barSvg = require('!svg-inline-loader!../../../../public/img/chart-bar.svg');
const downloadSvg = require('!svg-inline-loader!../../../../public/img/download.svg');


class BarChart extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {
		  mode: props.defaultMode || "bar",
		};
		this.setMode = this.setMode.bind(this);
		this.exportToCsv = this.exportToCsv.bind(this);
	}
	
	setMode(mode){
		this.setState({mode}, ()=>{
		});

		const { modeChange } = this.props;
		if(typeof modeChange == 'function')
			modeChange(mode);
	}
	
	exportToCsv(){
		const { data } = this.props;
		let result = [];
		const radioDataset = find(data.datasets, row=>row.id =='Radio');
		const collectionDataset = find(data.datasets, row=>row.id =='Collection');
		for(let index in data.labels) {
			result.push({
				period: data.labels[index],
				radio: radioDataset.data[index],
				collection: collectionDataset.data[index],
			})
		}
		const filename = CSV.CSVHeader('Spotify Discovery', 'Radio and Collection');
		return CSV.CSVExport(result, {filename});
	}

	
	renderToolbar(){
		let toolbar = [];
		const options = [
			{icon: barSvg, value: 'bar', label: "Bar Chart"},
			{icon: lineSvg, value: 'line', label: "Line Chart"},
			//{icon: tableSvg, value: 'table', label: "Table"},
		];
		toolbar.push(<div key="wrapper" className="ibox-action-wrapper">
		<div className="ibox-icon-holder mode-select">
			<ModeSelect options={options} selected={this.state.mode} onChange={this.setMode} isSearchable={ false } />
		</div>
		<div className="ibox-actions">
			<a key="download" title="Export CSV" onClick={this.exportToCsv} className="download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />	
		</div>
		</div>)
		return toolbar;
	}
	
	render (){
		const { metric, title, loading, data } = this.props;
		const { mode } = this.state;
		
		if(!data || !data.datasets)
			return null;
			
		const datasets = (data && data.datasets) ? data.datasets.filter(row=>['Radio', 'Collection'].includes(row.id)) : null;
		const baseline = data ? data.baseline : null;
		const options = baseline ?   { 
			plugins: {
				annotation: {
					annotations: {
					baseline: {
						type: 'line',
						yMin: baseline,
						yMax: baseline,
						borderColor: 'red',
						borderWidth: 2,
						label: {
							display: true,
							content: baseline,
							position: 'end'
						}
					}
					}
				}
			}
		} : null;

		return <Box title={title} spinnerEnabled={loading} toolbar={this.renderToolbar()}>
			{datasets && <div className="chart-block">
				{mode == 'bar' && <StackedBarChart shadowChart={true} shadowChartWidth={800} options={options} shadowChartHeight={300} data={{labels: data.labels, datasets}} id={'spotify_discovery_radio_collection'} />}
				{mode == 'line' && <LineChart shadowChart={true} shadowChartWidth={800} options={options} shadowChartHeight={300} data={{labels: data.labels, datasets}} id={'spotify_discovery_radio_collection'} period={this.props.period} dateGroup={this.props.period}  filteredLogVendors={['spotify']} />}

			</div>}
		</Box>
	}
}

export default BarChart;